import styled from 'styled-components';

export const RootLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
